<template>
    <section
        class="FeaturedDrives my-large desk-my-xlarge"
        @click="handleClick"
    >

        <div class="custom-cursor-area">
            <div class="custom-cursor">
                <div v-if="hoverSection == 'left'">
                    <BaseButton
                        modifier="squared"
                        tag="button"
                        align="right"
                    >
                        <BaseIcon
                            icon="arrow-left"
                            color="white"
                        />
                    </BaseButton>
                </div>
                <div v-if="hoverSection == 'centre'">
                    <BaseButton
                        modifier="squared"
                        tag="button"
                    >
                        <BaseIcon
                            icon="plus-icon"
                            color="white"
                        />
                    </BaseButton>
                </div>
                <div v-if="hoverSection == 'right'">
                    <BaseButton
                        modifier="squared"
                        tag="button"
                        align="left"
                    >
                        <BaseIcon
                            icon="arrow-left"
                            color="white"
                        />
                    </BaseButton>
                </div>
            </div>
            <BaseHeading
                class="h5"
                :preheading="heading"
            />

            <div
                class="relative"
            >
                <flickity
                    ref="flickity"
                    :options="flickityOptions"
                >
                    <div
                        v-for="item in items"
                        :key="item.id"
                        class="FeaturedDrives__item"
                    >

                        <header
                            class="FeaturedDrives__title h1"
                        >

                            <h2>{{ item.heading }}</h2>
                        </header>

                        <BaseImage
                            :placeholder="item.placeholder"
                            :srcset="item.image"
                            :ratio="item.ratio"
                        />

                        <div
                            class="FeaturedDrives__content"
                        >
                            <div>
                                <h6
                                    v-if="item.subheading"
                                    class="uppercase mb-small"
                                >
                                    {{ item.subheading }}
                                </h6>

                                <div v-html="itemDesc(item.description)"></div>
                            </div>
                        </div>
                    </div>
                </flickity>
            </div>
        </div>
        <div class="container">
            <ul class="FeaturedDrives__nav">
                <ProgressiveCircle
                    v-for="n in items.length"
                    :key="n"
                    :index="n - 1"
                    :activeSlide="activeSlide"
                    @setActive="setActive"
                />
            </ul>
        </div>
    </section>
</template>

<script>
import Flickity from './BaseCarousel.vue';
import ProgressiveCircle from './ProgressiveCircle.vue';
import { truncate } from 'lodash';

export default {
    name: 'FeaturedDrives',
    components: {
        Flickity,
        ProgressiveCircle
    },
    data() {
        return {
            flickityOptions: {
                initialIndex: 0,
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true,
                imagesLoaded: true,
                autoPlay: false,
                cellAlign: 'center'
            },
            activeSlide: 0,
            test: '',
            mouseX: 0,
            mouseY: 0,
            windowWidth: 0,
        }
    },
    props: {
        items: {
            type: Array
        },
        heading: {
            type: String,
            default: "Featured Drives"
        }
    },
    computed : {
        hoverSection() {
            if (this.mouseX < (this.windowWidth * 0.25)) return 'left'
            if (this.mouseX > (this.windowWidth * 0.75)) return 'right'
            return 'centre'
        }
    },
    methods: {
        setActive(index) {
            this.$refs.flickity.select(index);
        },
        handleClick() {
            if (this.hoverSection == 'left') this.previous();
            if (this.hoverSection == 'centre') this.open();
            if (this.hoverSection == 'right') this.next();
        },
        next() {
            this.$refs.flickity.next();
        },
        previous() {
            this.$refs.flickity.previous();
        },
        open() {
            window.location.href = this.items[this.activeSlide].url;
        },
        initCustomCursor() {
            const customCursor = document.querySelector(".custom-cursor");

            const render = () => {
                this.windowWidth = window.innerWidth
                || document.documentElement.clientWidth
                || document.body.clientWidth;
                customCursor.style.transform = `translate(${this.mouseX}px, ${this.mouseY}px)`;
                if (document.querySelector(".cursor-active")) {
                    requestAnimationFrame(render);
                }
            };

            this.$el.querySelector('.custom-cursor-area').addEventListener('mouseout', () => {
                this.$el.classList.remove('cursor-active');
            })

            this.$el.querySelector('.custom-cursor-area').addEventListener('mouseover', () => {
                this.$el.classList.add('cursor-active');
                render()
            })

            document.addEventListener("mousemove", (e) => {
                this.mouseX = e.clientX;
                this.mouseY = e.clientY - this.$el.querySelector('.custom-cursor-area').getBoundingClientRect().top;
            });
        },
        itemDesc(desc) {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = desc;

            const truncated = truncate(tempDiv.innerText, {
                length: 200,
                separator: /,? +/,
                omission: '…'
            });

            return `<p>${truncated}</p>`;
        }
    },
    mounted() {
        const carousel = document.querySelector('.FeaturedDrives')
        const flkty = this.$refs.flickity.data(carousel)

        flkty.on('change', () => {
            this.activeSlide = flkty.selectedIndex;
        });
        this.initCustomCursor();
    },

}
</script>
<style lang="scss" scoped>

    .FeaturedDrives {
        * {
            cursor: none !important;
        }

        position: relative;
    }

    .custom-cursor {
        position: absolute;
        z-index: 999;
        display: none;

        .cursor-active & {
            display: block;
        }

        ::v-deep .BaseButton {
            pointer-events: none;
        }
    }

    .BaseHeading {
        position: absolute;
        top: getSpacing('spacer');
        color: getColor('white');
        text-align: center;
        z-index: 2;
        width: 100%;
        pointer-events:none;
    }


    .FeaturedDrives__item {
        border-right: 1px solid getColor('white');
        width: calc(100% - 3rem);

        @include media-query(lap-and-up) {
            width: 80%;
            max-width: 1000px;

            &:after {
                content: '';
                position: absolute;
                height: 100%;
                width: 100%;
                background: getColor('black');
                left: 0;
                top: 0;
                opacity: 0.3;
            }
        }

    }

    .FeaturedDrives__content {
        padding-top: getSpacing('spacer');
        text-align: center;
        opacity: 0;
        transition: all ease-out 0.345s;
        line-height: 1.35;

        h6 {
            color: getColor('black');

            @include media-query(lap-and-up) {
                color: getColor('white');
            }
        }

        @include media-query(lap-and-up) {
            padding-bottom: getSpacing('medium');
            padding-top: 0;
            color: getColor('white');
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: flex-end;

            > div {
                position: relative;
                z-index: 1;
                max-width: 600px;
                margin: 0 auto;
                text-align: center;
                font-size: 0.9rem;
            }
        }

        .is-selected & {
            opacity: 1;
        }
    }

    .FeaturedDrives__title {
        position: absolute;
        display: none;
        align-items: center;
        justify-content: center;
        top: 0;
        height: 100%;
        z-index: 1;
        text-align: center;
        line-height: 0.8;
        width: 100%;
        pointer-events:none;

        h2 {
            font-size: 3rem;

            @include media-query(desk) {
                font-size: 5.6rem;
            }

            @include media-query(desk-wide) {
                font-size: 6.6rem;
            }

            @include media-query(tiny) {
                font-size: 1.8rem;
                margin-bottom: 2.3rem;
            }
        }

        @include media-query(lap-and-up) {
            left: -75px;
            right: -75px;
            width: auto;
        }

        .is-selected & {
            display: flex;
        }
    }

    .FeaturedDrives__nav {
        display:block;
        text-align: center;
        margin-top: getSpacing('medium');
    }

    .BaseImage {
        position: relative;
        .is-selected &:after {
            content: '';
            display:block;
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            background: getColor('black');
            opacity: 0.3;
        }
    }
</style>
